import React, { useState, useEffect } from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock/mock';
import SectionHeading from './SectionHeading';

export default function Testimonials() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive((a) => (a + 1) % testimonials.length), 5000);
    return () => clearInterval(t);
  }, []);

  const current = testimonials[active];

  return (
    <section id="testimonials" className="relative py-24 px-5 md:px-8 overflow-hidden">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          eyebrow="Blessings & Gratitude"
          title="Voices of Transformation"
        />

        <div
          className="reveal relative rounded-3xl p-10 md:p-14 mt-14 text-center"
          data-delay="120"
          style={{
            background: 'radial-gradient(circle at 50% 0%, #a71c14 0%, #7c130f 55%, #4a0a07 100%)',
            border: '1.5px solid #d9a63b',
            boxShadow: '0 20px 50px rgba(124,19,15,0.25)',
          }}
        >
          <Quote className="mx-auto text-[#e2b84f] mb-5" size={44} />
          <p
            key={active}
            className="font-body italic text-[#fdf4dd] text-xl md:text-2xl leading-relaxed min-h-[120px] transition-opacity duration-500"
          >
            “{current.text}”
          </p>
          <div className="flex justify-center gap-1 mt-6">
            {Array.from({ length: current.rating }).map((_, i) => (
              <Star key={i} className="text-[#f2d68a] fill-[#f2d68a]" size={20} />
            ))}
          </div>
          <p className="font-display font-bold text-[#f2d68a] text-xl mt-5">{current.name}</p>
          <p className="font-heading tracking-widest uppercase text-[#e2b84f] text-xs mt-1">
            {current.city}
          </p>

          {/* dots */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                aria-label={`Testimonial ${i + 1}`}
                className={`h-2.5 rounded-full transition-all duration-300 ${
                  i === active ? 'w-8 bg-[#f2d68a]' : 'w-2.5 bg-[#e2b84f]/40'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
